import {useContext} from 'react'
import TermsOfUse from '../StaticPages/TermsOfUse/TermsOfUse'
import Helmet from 'react-helmet'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import {  LanguageContext } from '../context';
import TermsOfUseEn from '../StaticPages/TermsOfUse/TermsOfUse'
import MetaTags from '../Components/MetaTags/MetaTags'

const TermsOfUsePage = () => {

    const { language } = useContext(LanguageContext);
  return (
    <div>
      <MetaTags title={"Terms of Use page"} description={"Terms of Use page"}/>
       
      
      <Header/>
      <div role="main" aria-label="Terms of Use">
      {
          language=="he"?<TermsOfUse/>: <TermsOfUseEn/>
      }
    
      
    
   
      </div>
        <Footer/>

    </div>
  )
}

export default TermsOfUsePage